// extracted by mini-css-extract-plugin
export var cardHeight = "sideBarReceitas-module--cardHeight--661a4";
export var inputReceita = "sideBarReceitas-module--inputReceita--6aac1";
export var instHeight = "sideBarReceitas-module--instHeight--26178";
export var searchIcon = "sideBarReceitas-module--searchIcon--dea0b";